const ACCEPTED_RECIPE_IMAGE_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',
]);

/** Camera captures often omit MIME type; default to JPEG for upload. */
export function resolveRecipeImageContentType(file: File): string {
    const type = file.type?.trim().toLowerCase();
    if (!type) return 'image/jpeg';
    if (type === 'image/heic' || type === 'image/heif') return type;
    if (ACCEPTED_RECIPE_IMAGE_TYPES.has(type)) return type;
    return 'image/jpeg';
}

export function isAllowedRecipeImageFile(file: File): boolean {
    const type = file.type?.trim().toLowerCase();
    if (!type) return true;
    return ACCEPTED_RECIPE_IMAGE_TYPES.has(type);
}
